module.exports = require("core-js/library/fn/object/assign");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/assign.js